<template>
  <div class="exchange">
    <app-cells>
      <h1 class="title">Currency exchanger</h1>
    </app-cells>
    <div class="exchange__row">
      <app-form-group label="Amount" label-for="amount" class="form-group--no-indent">
        <app-input
          v-model.number="amount"
          @input.native="onCalculateResult"
          id="amount"
          type="number"
          min="0"
          placeholder="Type"
          name="amount"
        />
      </app-form-group>
      <app-form-group label="From" class="form-group--no-indent">
        <app-select
          @input="onCalculateResult"
          v-model="from"
          :options="currency_options"
          :clearable="false"
          placeholder="Select"
        />
      </app-form-group>
      <button class="exchange__btn" @click="onChangeCurrencyPlace" :disabled="!from || !to">
        <img src="@/assets/img/exchange-arrow.svg" alt="Change">
      </button>
      <app-form-group label="To" class="form-group--no-indent">
        <app-select
          @input="onCalculateResult"
          v-model="to"
          :options="currency_options"
          :clearable="false"
          placeholder="Select"
        />
      </app-form-group>
    </div>
    <template v-if="exchange_result">
      <app-cells>
        <h2 class="title">Converting result</h2>
        <app-button
          v-tooltip="{content: 'Amount * Currency rate + 1.5% = result', placement: 'top-end', offset: 10}"
          theme="tooltip">
        </app-button>
      </app-cells>
      <div class="exchange__result">
        <img src="@/assets/img/exchange-result.svg" alt="Result">
        <span class="exchange__block">
        <span>{{ new Intl.NumberFormat('ru-RU').format(amount) }} {{ from.name }} = </span>
        <span>{{ new Intl.NumberFormat('ru-RU').format(exchange_result.amount) }} {{ to.name }}</span>
      </span>
      </div>
    </template>
  </div>
</template>

<script>
import { getCurrencyList, postCurrencyCalculator } from '@/http'

export default {
  name: 'CurrencyExchange',
  data() {
    return {
      amount: null,
      from: '',
      to: '',
      currency_options: [],
      exchange_result: null,
    }
  },
  created() {
    getCurrencyList()
      .then(response => {
        this.currency_options = response.data
      })
  },
  methods: {
    onCalculateResult() {
      if (!this.from || !this.to || !this.amount) return
      postCurrencyCalculator({from_currency: this.from.code, to_currency: this.to.code,  amount: this.amount})
        .then(response => {
          this.exchange_result = response.data
        })
    },
    onChangeCurrencyPlace() {
      const to = this.to
      this.to = this.from
      this.from = to
      this.onCalculateResult()
    }
  }
}
</script>

<style lang="sass" scoped>
.exchange__row
  display: grid
  grid-template-columns: 100px 200px 38px 200px 130px
  align-items: flex-end
  gap: 20px
  margin-bottom: 30px

.exchange__btn
  display: flex
  align-items: center
  justify-content: center
  width: 38px
  height: 38px
  border: 1px solid #ddd
  border-radius: 50%
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
  background-color: #fff
  transition: background-color 0.3s, border-color 0.3s, opacity 0.3s

  img
    transition: filter 0.3s

  &:active
    background-color: $color-theme
    border-color: $color-theme

    img
      filter: brightness(10)

  @media (hover: hover)
    &:hover,
    &:focus-visible
      background-color: $color-theme
      border-color: $color-theme

      img
        filter: brightness(10)

  &:disabled
    pointer-events: none
    opacity: 0.5

.exchange__result
  display: flex
  gap: 15px
  align-items: flex-start
  width: max-content
  padding: 16px
  border-radius: 10px
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.1)

  img
    flex-shrink: 0

.exchange__block
  span
    display: block
    font-size: 32px
    font-weight: 500

    &:first-child
      margin-bottom: 10px
      padding-top: 6px
      font-size: 14px
      font-weight: 600
</style>
